import React, { useState, useEffect } from 'react';
import AdminLayout from '@/components/AdminLayout';
import { Trash2, Star } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const Reviews = () => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchReviews();
  }, []);

  const fetchReviews = async () => {
    try {
      const response = await fetch(`${BACKEND_URL}/api/admin/reviews`, {
        credentials: 'include'
      });
      
      if (response.ok) {
        const data = await response.json();
        setReviews(data);
      }
    } catch (error) {
      console.error('Failed to fetch reviews:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (reviewId) => {
    if (!window.confirm('Are you sure you want to delete this review?')) return;

    try {
      const response = await fetch(`${BACKEND_URL}/api/admin/reviews/${reviewId}`, {
        method: 'DELETE',
        credentials: 'include'
      });

      if (response.ok) {
        fetchReviews();
      }
    } catch (error) {
      console.error('Failed to delete review:', error);
    }
  };

  const renderStars = (rating) => {
    return (
      <div className="flex gap-1">
        {[1, 2, 3, 4, 5].map((star) => (
          <Star
            key={star}
            size={16}
            className={star <= rating ? 'fill-yellow-400 text-yellow-400' : 'text-gray-300'}
          />
        ))}
      </div>
    );
  };

  return (
    <AdminLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white">Reviews</h1>
          <p className="text-gray-600 dark:text-gray-400">Manage product reviews</p>
        </div>

        <div className="bg-white dark:bg-gray-800 rounded-lg shadow overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50 dark:bg-gray-900">
                <tr>
                  <th className="text-left py-3 px-4 text-gray-600 dark:text-gray-400">Product</th>
                  <th className="text-left py-3 px-4 text-gray-600 dark:text-gray-400">User</th>
                  <th className="text-left py-3 px-4 text-gray-600 dark:text-gray-400">Rating</th>
                  <th className="text-left py-3 px-4 text-gray-600 dark:text-gray-400">Comment</th>
                  <th className="text-left py-3 px-4 text-gray-600 dark:text-gray-400">Date</th>
                  <th className="text-left py-3 px-4 text-gray-600 dark:text-gray-400">Actions</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="6" className="text-center py-8 text-gray-500">Loading...</td>
                  </tr>
                ) : reviews.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="text-center py-8 text-gray-500">No reviews found</td>
                  </tr>
                ) : (
                  reviews.map((review) => (
                    <tr key={review.id} className="border-t dark:border-gray-700">
                      <td className="py-3 px-4">
                        <span className="font-medium text-gray-900 dark:text-white">
                          {review.product?.name || 'Unknown Product'}
                        </span>
                      </td>
                      <td className="py-3 px-4">
                        <div className="text-gray-900 dark:text-white">{review.user?.name}</div>
                        <div className="text-sm text-gray-500">{review.user?.email}</div>
                      </td>
                      <td className="py-3 px-4">{renderStars(review.rating)}</td>
                      <td className="py-3 px-4 text-gray-600 dark:text-gray-400 max-w-md truncate">
                        {review.comment || 'No comment'}
                      </td>
                      <td className="py-3 px-4 text-gray-600 dark:text-gray-400">
                        {new Date(review.created_at).toLocaleDateString()}
                      </td>
                      <td className="py-3 px-4">
                        <button
                          onClick={() => handleDelete(review.id)}
                          className="p-2 text-red-600 hover:bg-red-50 rounded"
                          title="Delete"
                        >
                          <Trash2 size={16} />
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default Reviews;